<template>
    <div style="width: 100%;height: 100%">
        <!-- 卡片视图 -->
        <el-card>
            <el-row :gutter="20">
                <el-col :span="4">
                    <el-button type="primary" @click="create">创建总部</el-button>
                </el-col>
            </el-row>

            <div style="margin-top: 15px;display: flex">
                    <div  style="width: 100px;line-height: 2.5em" >
                        根据名称检索：
                    </div>
                    <el-input placeholder="请输入内容" v-model="input" class="input-with-select"  @keyup.enter.native="searchList">
                        <el-button slot="append" icon="el-icon-search" @click="searchList"></el-button>
                    </el-input>
                     <el-button  @click="clear"  style="margin-left: 10px" type="info">清除</el-button>
            </div>

            <!-- 表格数据 -->
            <el-table :data="goodsList" border stripe v-loading="loading">
                <el-table-column type="index"></el-table-column>
                <el-table-column label="名称" prop="name" ></el-table-column>
                <el-table-column label="创建时间" prop="create_time" >
                    <template slot-scope="scope">{{scope.row.create_time| dataFormat}}</template>
                </el-table-column>
                <el-table-column label="更新时间" prop="update_time" >
                    <template slot-scope="scope">{{scope.row.update_time | dataFormat }}</template>
                </el-table-column>
                <el-table-column label="操作" >
                    <template slot-scope="scope">
                        <el-button type="primary" icon="el-icon-edit" size="mini"  @click="toDetail(scope.row.id)">查看详情</el-button>
                    </template>
                </el-table-column>
            </el-table>
            <!-- 分页区域 -->
            <el-pagination
                    @size-change="handleSizeChange"
                    @current-change="handleCurrentChange"
                    :current-page="queryInfo.pagenum"
                    :page-sizes="[5, 10, 15, 20]"
                    :page-size="queryInfo.pagesize"
                    layout="total, sizes, prev, pager, next, jumper"
                    :total="total"
                    background
            ></el-pagination>
        </el-card>

    </div>
</template>

<script>
    export default {
        name: "head_list",
        data () {
            return {
                queryInfo: {
                    query: '',
                    pagenum: 1,
                    pagesize: 10
                },
                // 商品列表
                goodsList: [
                ],
                // 商品总数
                total: 0,
                offset:0,
                oldoffset:0,
                isOpen:false,
                info:{
                    name:"",
                    desc:"",
                    phone:""
                },
                loading:true,
                input: '',
                selectname: ''
            }
        },
        created(){
            this.getList();
        },
        methods:{
            async getList(){
                let that=this;
                const { data: res } = await this.$http.post('',
                    {
                        "oper": "get_multi",
                        "ent": "head",
                        "info": {
                            "count":this.queryInfo.pagesize,
                            "offset":this.offset,
                        }
                    }
                )
                console.log(res)
                this.goodsList = res.data.data_list;
                that.total = res.data.total_count;
                this.loading=false;
                this.oldoffset=this.offset;
                this.offset+=this.queryInfo.pagesize
            },
            create(){
                this.$prompt('输入创建总部名称', '提示', {
                    confirmButtonText: '确定',
                    cancelButtonText: '取消',
                }).then(async ({ value }) => {
                    const { data: res } = await this.$http.post('', {
                        "oper": "add",
                        "ent": "head",
                        "info": {
                            "name":value
                        }
                    })
                    console.log(res)
                    if (res.code !== 0){
                        this.$message("创建失败");
                    }
                    else{
                        this.$message({
                            type: 'success',
                            message: '创建成功'
                        });
                        this.loading=false;
                        this.offset=this.oldoffset;
                        this.getList();
                    }
                }).catch(() => {
                    this.$message({
                        type: 'info',
                        message: '取消输入'
                    });
                });
            },

            handleCurrentChange (newSize) {
                this.queryInfo.pagenum = newSize;
                this.offset=(newSize-1)*this.queryInfo.pagesize;
                this.oldoffset=this.offset;
                this.getList()
            },
            handleSizeChange (newSize) {
                this.queryInfo.pagesize = newSize
                this.offset=0
                this.oldoffset=this.offset;
                this.getList()
            },

            toDetail(id){
                console.log(id)
                this.$router.push({ name: 'head-detail', params: { id: id }});
            },
            async  searchList(){
                this.loading=true;
                var info={};
                info["name"]=this.input;
                const { data: res } = await this.$http.post('',
                    {
                        "oper": "get_multi",
                        "ent": "head",
                        "info":info
                    }
                )
                this.goodsList=null;
                this.goodsList=new Array;
                this.goodsList = res.data.data_list;
                this.total = res.data.total_count;
                this.loading=false;
            },
            clear(){
                this.offset=0
                this.oldoffset=this.offset;
                this.selectname="";
                this.input="";
                this.loading=true;
                this.goodsList=null;
                this.goodsList=new Array;
                this.getList();
            }

        }
    }
</script>

<style scoped>
</style>
